import { Text } from '@collable/ui'
import ContentBox from './ContentBox'
import GoogleLoginButton from './GoogleLoginBtn'

const GoogleLoginSection = () => {
  return (
    <ContentBox gap={20} align="center">
      <Text size="body3" fontWeight="regular" color="labelNeutral">
        구글 계정으로 간편하게 시작할 수 있어요!
      </Text>
      <GoogleLoginButton />
    </ContentBox>
  )
}

export default GoogleLoginSection
